<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'GED - CADASTRO DE TIPO DE ATIVIDADE'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label ><small v-show="form.nome.required" class="text-danger">*</small> Tipo de Atividade:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o tipo de atividade'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import GedTipoTarefaForms from './gedtipotarefaadd-form.js'
import GedTipoTarefaRepository from '@/shared/http/repositories/ged/gedtipotarefa.js'

const GedTipoTarefaModel = {
  id: 0,
  nome: ''
}

export default {
  name: 'GedTipoTarefaAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: GedTipoTarefaModel,
      form: GedTipoTarefaForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      GedTipoTarefaRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      GedTipoTarefaRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/gedtipotarefa/components/add/gedtipotarefadd.vue